import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("brimi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("brimi_token");
      localStorage.removeItem("brimi_user");
    }
    // Normalize FastAPI error detail to a string so toast/UI can render safely
    const detail = err.response?.data?.detail;
    if (detail && typeof detail === "object") {
      err.response.data.detail = detail.message || detail.error || "Request failed";
      err.response.data._detailRaw = detail;
    }
    // 402 = subscription required; the SubscriptionContext shows a modal,
    // so components should NOT also show a toast for these.
    err.isSubscriptionError = err.response?.status === 402;
    return Promise.reject(err);
  },
);
